import { createContext } from "react";
import {
  ClientSideConfigEntry,
  QueryDescription,
} from "common/utils/queryBuilder";
import { InvalidQueryConfig } from "../../../generated/graphql";
import { SavedView } from "./TableSettings/utils";

type TableContextType = {
  name: string;
  currentQuery?: QueryDescription;
  currentView?: Maybe<SavedView>;
  defaultView?: Maybe<SavedView>;
  columnConfig?: Array<ClientSideConfigEntry>;
  invalidQueryConfig?: InvalidQueryConfig | null;
};
export const TableContext = createContext<TableContextType>({
  name: "",
});
